/**
 * @generated SignedSource<<8639ffda36dc801ca8a54fb9739cce07>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sbSharedAppliedFiltersHelpers_itemSearch$data = {
  readonly clearAppliedFiltersLinkReference: string | null;
  readonly " $fragmentType": "sbSharedAppliedFiltersHelpers_itemSearch";
};
export type sbSharedAppliedFiltersHelpers_itemSearch$key = {
  readonly " $data"?: sbSharedAppliedFiltersHelpers_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"sbSharedAppliedFiltersHelpers_itemSearch">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sbSharedAppliedFiltersHelpers_itemSearch"
};

(node as any).hash = "0363dc29d629112eeb467f1db878d867";

export default node;
